<ul>
  <li *ngFor="let payment of payments">
    <svg-icon [name]="payment"></svg-icon>
  </li>
</ul>